module.exports = __webpack_public_path__ + "static/media/closeModal.d472ad6d.mp3";